import React from 'react';
import classNames from 'classnames/bind';
import styles from './NoticeText.module.scss';

const cx = classNames.bind(styles);

const NoticeText = ({ children, useIco = false, style = null }) => (
	<div style={style}>
		<p className={cx('notice', { ico: useIco })}>{children}</p>
	</div>
);

export default NoticeText;
